import { Link } from 'react-router-dom'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Form } from 'semantic-ui-react'
import {
    DangerText,
    LoaderBar,
    ScreenHeight,
    TitleText,
    ImageContainer,
} from 'components'
import { AuthService, DefaultText, FormErrorText } from 'utility'
import {
    AppPrimaryButton,
    CommanAuthScreenLogin,
    FormTextFormField,
} from 'elements'
import { useNotification } from 'hooks'
import { Images } from 'assets'
import { useTabletAndBelowMediaQuery } from 'layout'

const ForgotPasswordSchema = yup.object().shape({
    Email: yup
        .string()
        .trim(FormErrorText.SpacesNotAllowed)
        .strict()
        .email('Enter a valid email')
        .required('Email is required'),
})

export const ForgotPasswordScreen = () => {
    const [processing, setProcessing] = useState('')
    const [error, setError] = useState('')
    const isMobile = useTabletAndBelowMediaQuery()
    const { successToast } = useNotification()
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(ForgotPasswordSchema),
    })

    const submit = async formData => {
        try {
            setError('')
            setProcessing('Processing')
            await AuthService.forgotPassword(formData.Email)
            successToast('Reset password link sent successfully to your mail')
        } catch (error) {
            setError(DefaultText.defaultError)
            successToast(DefaultText.defaultError)
        } finally {
            setProcessing('')
        }
    }

    return (
        <ScreenHeight className="container">
            <CommanAuthScreenLogin isMobile={isMobile}>
                {processing && <LoaderBar content={processing} />}
                <TitleText>
                    <ImageContainer src={Images.Logo} className="img" />
                    <span>Forgot Password</span>
                </TitleText>
                <Form
                    noValidate
                    onSubmit={handleSubmit(submit)}
                    className="mt-5"
                >
                    <FormTextFormField
                        control={control}
                        label="Email"
                        name="Email"
                        placeholder="Email"
                        errors={errors?.Email}
                        defaultValue=""
                    />
                    {error && <DangerText>{error}</DangerText>}
                    <AppPrimaryButton fluid className="mt-2">
                        Submit
                    </AppPrimaryButton>
                    <Link
                        to="/sign-in"
                        className="d-flex justify-content-center mt-3"
                    >
                        Back
                    </Link>
                </Form>
            </CommanAuthScreenLogin>
        </ScreenHeight>
    )
}
